// role.guard.ts

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { USER_ROLE_ITEMS } from '../constants/common-constants';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
   userRoleItems = USER_ROLE_ITEMS;
  constructor(private authService: AuthenticationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
   
    const userData = this.authService.GetuserData();
    const gdcAdminRole = this.userRoleItems.find(
      x => x.label === 'GDC Admin'
    );

    const isGdcAdmin = userData?.user_role === gdcAdminRole?.value;
    
    const blockedRoutesForGdcAdmin = ['user-management', 'project-management', 'report-management'];

    if (isGdcAdmin && blockedRoutesForGdcAdmin.includes(route.routeConfig?.path || '')) {
      this.router.navigate(['/unauthorized']);
      return false;
    }

    const expectedRole = route.data["role"];

    if (!this.authService.isAuthenticated() || !this.authService.hasRole(expectedRole)) {
      // Redirect to the unauthorized page if not authenticated or lacking the required role
      this.router.navigate(['/unauthorized']);
      return false;
    }

    return true;
  }
}

